__turbopack_context__.v({
  "link": "style-module-scss-module__vfc_Fq__link",
  "primary": "style-module-scss-module__vfc_Fq__primary",
  "street-address": "style-module-scss-module__vfc_Fq__street-address",
  "tertiary": "style-module-scss-module__vfc_Fq__tertiary",
});
